import { App, BackButtonListenerEvent } from '@capacitor/app';
import { IonAccordion, IonAccordionGroup, IonApp, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonNote, IonSegment, IonSegmentButton, IonText, IonThumbnail, IonToolbar, useIonAlert } from '@ionic/react'
import { closeOutline } from 'ionicons/icons';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppHeader from '../../components/AppHeader/AppHeader';
import { useAppSelector } from '../../services/redux/hook';
import "./CashoutStatus.css";
import { Browser } from '@capacitor/browser';
import { useHistory } from 'react-router';

import { CashoutTransactionStatus } from '../../types/types';

interface CashoutStatusProps extends PropsWithChildren {

  closeAction: Function;
  operation: any;


}

const CashoutStatus: React.FC<CashoutStatusProps> = (props) => {
  const { t, i18n } = useTranslation();

  const [presentAlert] = useIonAlert();
  const history = useHistory();

  const [pageHeader, setPageHeader] = useState<string>(t('cashout.status.page.PAGE_HEADER') as string);
  const asset = useAppSelector((state) => state.selectedAsset);
  const [segmentValue, setSegmentValue] = useState('status');

  const [stepOne, setstepOne] = useState("step")
  const [steptwo, setsteptwo] = useState("step")
  const [stepThree, setstepThree] = useState("step")
  const [stepFour, setstepFour] = useState("step")

  const [stepOneName, setstepOneName] = useState<string>(t('cashout.status.step1.LABEL') as string)
  const [steptwoName, setsteptwoName] = useState<string>(t('cashout.status.step2.LABEL') as string)
  const [stepThreeName, setstepThreeName] = useState<string>(t('cashout.status.step3.LABEL') as string)
  const [stepFourName, setstepFourName] = useState<string>(t('cashout.status.step4.LABEL') as string)
  const [message, setmessage] = useState("")
  const [hideSummary, setHideSummary] = useState(false);

  const presentErrorAlert = (error: any) => {

    presentAlert({
      header: 'Error',
      message: `${error.data}`,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
            return
          }
        }
      ],

    })

  }

  let cashingOut = parseFloat(props.operation.info.amount_in ? props.operation.info.amount_in : 0) - parseFloat(props.operation.info.amount_fee ? props.operation.info.amount_fee : 0);
  let cashOutFee = parseFloat(props.operation.info.amount_fee ? props.operation.info.amount_fee : "")

  const segmentChanged = (value: any) => {

    setSegmentValue(value)

  }

  // App.addListener('backButton', (ev: BackButtonListenerEvent) => {
  //   props.closeAction()
  // });

  useEffect(() => {
    let backButtonListener:any;

    const setupBackButtonListener = async () => {
        backButtonListener = await App.addListener('backButton', (ev: BackButtonListenerEvent) => {
            props.closeAction();
        });
    };

    setupBackButtonListener();

    // Cleanup function
    return () => {
        backButtonListener?.remove();
    };
}, [props.closeAction]);

  const j = {
    incomplete: "step is-incomplete",
    pending: "step is-pending",
    fail: "step is-fail",
    active: "step is-active",
    complete: "step is-complete",
  }


  useEffect(() => {

    const init = async () => {

      try {

        let status = props.operation.info.status;
        
        let message: string = props.operation.info.status_message;

        if (status === CashoutTransactionStatus.pending_user_transfer_start) {
          setstepOne(j.incomplete);
          setstepOneName(t('cashout.status.step.Incomplete.LABEL') as string);
          setHideSummary(true);


        }
        if (status === CashoutTransactionStatus.processing) {
          setstepOne(j.complete)
          setsteptwo(j.active)
          setsteptwoName(t('cashout.status.step.Processing.LABEL') as string)
          //setPageHeader("In processing")
          setmessage(t('cashout.status.PROCESSING.MESSAGE') as string);
          setHideSummary(true);


        }

        if (status === CashoutTransactionStatus.pending_user_transfer_start) {
          setstepOne(j.incomplete)
          setmessage(t('cashout.status.INCOMPLETE.MESSAGE') as string);
        }

        if (status === "received") {
          setstepOne(j.complete)
          setsteptwo(j.complete)
        }

        if (status === CashoutTransactionStatus.pending_user) {
          setstepOne(j.complete)
          setsteptwo(j.complete)
          setstepThree(j.pending)
          setstepThreeName(t('cashout.status.step.PendingUser.LABEL') as string)
          setmessage(t('cashout.status.PENDING-FORM.MESSAGE') as string);
          //setPageHeader("Your transaction is pending")
        }

        if (status === CashoutTransactionStatus.pending_user_transfer_complete) {
          setstepOne(j.complete)
          setsteptwo(j.complete)
          setstepThree(j.complete)
          //setPageHeader("pick up")
          setmessage(t('cashout.status.PENDING-PICKUP.MESSAGE') as string);
        }

        if (status === CashoutTransactionStatus.completed) {
          setstepOne(j.complete)
          setsteptwo(j.complete)
          setstepThree(j.complete)
          setstepFour(j.complete)
          //setPageHeader("Your Transaction is complete")
          setmessage(t('cashout.status.COMPLETED.MESSAGE') as string);


        }

        if (message === "Transaction could not be submitted due to error") {
          setstepOne(j.fail)
          setstepOneName("Error")
          setPageHeader("")
          setHideSummary(true);
        }

        if (status === CashoutTransactionStatus.failed && message.toLowerCase().includes('expired')) {

          setstepOne(j.complete)
          setsteptwo(j.complete)
          setstepThree(j.fail)
          setstepThreeName(t('cashout.status.EXPIRED.LABEL') as string)
          //setPageHeader("Your transaction has failed")
          setmessage(t('cashout.status.EXPIRED.MESSAGE') as string);
          setHideSummary(true);

        }

        if (status === CashoutTransactionStatus.failed && message.toLowerCase().includes('refunded')) {

          setstepOne(j.complete)
          setsteptwo(j.complete)
          setstepThree(j.fail)
          setstepThreeName(t('cashout.status.REFUNDED.LABEL') as string)
          //setPageHeader("Your transaction has failed")
          setmessage(t('cashout.status.REFUNDED.MESSAGE') as string);
          setHideSummary(true);

        }

      } catch (error) {
        presentErrorAlert({ data: t('application.uncaught.ERROR') })

      }

    }

    init();

  }, [])

  function goToPaymentReviewPage(val: any) {
    history.push({
      pathname: '/tabs/accounts/cashout/review',
      state: {
        detail: {
          paymentInfo: val
        }
      }
    })
    props.closeAction();

  }

  const FillMoneygramForm = async (url: string) => {

    await Browser.open({ url: url });

  }
  const TransaferComplete = async (url: string) => {

    await Browser.open({ url: url });

  }

  // const goToAmountPage =(operation:any)=>{
  //   props.closeAction();
  //   history.push('/tabs/accounts/cashout/amount')
  // }
 
  return (
    <IonApp>

      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="start">
            <IonButton onClick={() => { props.closeAction() }}>
              <IonIcon slot="icon-only" icon={closeOutline} color="danger" />
            </IonButton>
          </IonButtons>
        </IonToolbar>


      </IonHeader>

      <IonContent>

        <AppHeader
          title={pageHeader}

        >
        </AppHeader>
        <IonItem lines="none">

          <IonSegment className="Segmentstatus" value={segmentValue} mode='ios' onIonChange={(e:any) => segmentChanged(e.detail.value)}>
            <IonSegmentButton value="status" className='SegmentstatusButton'>
              <IonLabel>{t('cashout.status.page.ORDER_STATUS_LABEL')}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="details" className='SegmentstatusButton'>
              <IonLabel>{t('cashout.status.page.ORDER_STATUS_DETAIL')}</IonLabel>
            </IonSegmentButton>
          </IonSegment>

        </IonItem>


        <IonItem lines='none' style={{ display: "inline-table" }}>

          <IonThumbnail className="accountsPage_Thumbnail_Flag_cashout"  >
            <img src={asset.icon} />
          </IonThumbnail>
        </IonItem>
        {
          segmentValue === 'status' ? (
            <>

              <ol className="steps">
                <li className={stepOne} >
                  {stepOneName}
                </li>
                <li className={steptwo} >
                  {steptwoName}
                </li>
                <li className={stepThree} >
                  {stepThreeName}
                </li>
                <li className={stepFour} >
                  {stepFourName}
                </li>
              </ol>

              {/* <IonItem lines="none" style={{ top: "2.5vh" }}>


                <IonText  >
                  <p className='text-xs'>{message}
                    {(props.operation?.status === 'pending_user_transfer_start' ?
                      <IonButton fill="clear" color={"primary"} style={{ fontWeight: "bold" }} onClick={() => {
                        goToPaymentReviewPage(props.operation)
                      }}>Complete it</IonButton>
                      : (props.operation?.status === 'pending_user' ?
                        <IonButton fill="clear" color={"primary"} style={{ fontWeight: "bold" }} onClick={() => {
                          FillMoneygramForm(props.operation.more_info_url)
                        }}>Fill the form</IonButton>
                        : (props.operation?.status === 'pending_user_transfer_complete' ?
                          <IonButton fill="clear" color={"primary"} style={{ fontWeight: "bold" }} onClick={() => {
                            TransaferComplete(props.operation.more_info_url)
                          }}>click</IonButton> : "")))}</p>
                </IonText>
              
              </IonItem> */}

            </>


          ) : (<>

            <IonItem lines='none'>
              <IonLabel>
                <IonText className="ion-text-wrap">
                  <h4>{t('cashout.status.page.ID_LABEL')}</h4>
                </IonText>
                <IonNote className="operationsItem_IonNote">
                  {props.operation.info.id}
                </IonNote>
              </IonLabel>
            </IonItem>
            <IonItem lines='none'>

              <IonLabel>
                <IonText className="ion-text-wrap">
                  <h3>{t('cashout.status.SUMMARY.DELIVERY_1')} {props.operation.info.asset_code} {t('cashout.status.SUMMARY.DELIVERY_2')}</h3>
                </IonText>

                <IonNote className="operationsItem_IonNote" >


                  {props.operation.info.description}
                </IonNote>


              </IonLabel>

            </IonItem>
            <IonItem lines='none' hidden={hideSummary} >
              <IonLabel>
                <IonText className="ion-text-wrap">
                  <h3>{t('cashout.status.SUMMARY.LABEL')}</h3>
                </IonText>


                <IonAccordionGroup className='AccordionStyle' value={"first"} >
                  <IonAccordion value="first">
                    <IonItem slot="header" color="light" lines='none'>
                      <IonLabel>{t('cashout.status.TRANSFERING.LABEL')}  <b>{parseFloat(props.operation.info.amount_in).toFixed(2)}  {props.operation.info.asset_code}</b></IonLabel>
                    </IonItem>

                    <div className="ion-padding" slot="content" style={{ backgroundColor: "#f4f4f8", padding: "0px" }}>
                      <hr color='black' style={{ margin: "0px" }} />
                      <IonItem lines='none' color="light">

                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                          {t('cashout.status.WITHDRAW.LABEL')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>

                          {cashingOut.toFixed(2)} {props.operation.info.asset_code}


                        </IonNote>
                      </IonItem>


                      <IonItem lines='none' color="light">

                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                          {t('cashout.status.FEE.LABEL')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>

                          {cashOutFee.toFixed(2)} {props.operation.info.asset_code}
                        </IonNote>
                      </IonItem>

                    </div>

                  </IonAccordion>
                </IonAccordionGroup>



              </IonLabel>



            </IonItem>

          </>)
        }

        <IonCard style={{ marginTop: "15%" }}>
          <IonCardContent>
            {message}
          </IonCardContent>
        </IonCard>

      </IonContent>
      <IonFooter>
        <IonButton hidden={(props.operation.info.status === CashoutTransactionStatus.completed
          || props.operation.info.status === CashoutTransactionStatus.failed || props.operation.info.status === CashoutTransactionStatus.processing)}
          type="submit"
          expand="block"
          id='pageFooterButton'
          onClick={() => {
            props.operation.info.status === CashoutTransactionStatus.pending_user_transfer_start ? goToPaymentReviewPage(props.operation.info) :
              props.operation.info.status === CashoutTransactionStatus.pending_user
                ? FillMoneygramForm(props.operation.info.more_info_url) : TransaferComplete(props.operation.info.more_info_url)
          }}

        >
          {(
            props.operation.info.status === CashoutTransactionStatus.pending_user_transfer_start ? t('cashout.status.BTN.COMPLETE.LABEL') :
              props.operation.info.status === CashoutTransactionStatus.pending_user ? t("cashout.status.PENDING-FORM.BTN.LABEL") :
                props.operation.info.status === CashoutTransactionStatus.pending_user_transfer_complete ? t('cashout.satus.PICKUP-MONEY.BTN.LABEL') : ""
          )}
        </IonButton>
       
        {/* <IonCard >
         
          <IonCardContent>
            
          <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" style={{width:"7.5%"}}>
            <g id='bulbAnimation'>

            <path  d="M304 384v-24c0-29 31.54-56.43 52-76 28.84-27.57 44-64.61 44-108 0-80-63.73-144-144-144a143.6 143.6 0 00-144 144c0 41.84 15.81 81.39 44 108 20.35 19.21 52 46.7 52 76v24M224 480h64M208 432h96M256 384V256" 
            fill="none" stroke="#ffc409" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32"/>
            <path d="M294 240s-21.51 16-38 16-38-16-38-16" fill="none" stroke="#ffc409" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32"/>
            </g>
            </svg>
            
            {props.operation.status_message ? props.operation?.status_message : "this content has to be update"}
          </IonCardContent>

        </IonCard> */}
      </IonFooter>
    </IonApp>
  )
}

export default CashoutStatus




